import React, { useEffect } from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { registerIconLibrary } from '@shoelace-style/shoelace/dist/utilities/icon-library'
import BigNumber from 'bignumber.js'
import { useAccountEventListener } from 'hooks/useAccountEventListener'
import useScrollOnRouteChange from 'hooks/useScrollOnRouteChange'
import useRefLink from 'hooks/useRefLink'
import { useAffiliate } from 'state/affiliate/hooks'
import { usePollBlockNumber } from 'state/block/hooks'
import { useInitialPoolsData } from 'state/pools/hooks'
import { useReferrals } from 'state/referrals/hooks'
import { useFetchProfile } from 'state/profile/hooks'
import { DatePickerPortal } from 'components/DatePicker'
import { initAmplitude } from 'utils/analytics'
// import { initKayako } from 'utils/kayako'
import GlobalStyles from 'style/Global'

import { ToastListener } from 'contexts/ToastsContext'

import Layout from 'Layout'
import useAnalytics from 'hooks/useAnalytics'
import useNetworkSwitching from 'hooks/useNetworkSwitching'

// TODO: move themes for nominex and nomiswap to separate package
import '@shoelace-style/shoelace/dist/themes/dark.css'
import './style/tailwind.css'
import './style/themes/dark.css'

window.Nomiswap = {
  version: import.meta.env.VITE_APP_VERSION,
}

// This config is required for number formatting
BigNumber.config({
  EXPONENTIAL_AT: 1000,
  DECIMAL_PLACES: 80,
})

initAmplitude()
// initKayako()

const App: React.FC = () => {
  useAccountEventListener()
  useInitialPoolsData()
  usePollBlockNumber()
  useFetchProfile()
  useScrollOnRouteChange()
  useRefLink()
  useAffiliate()
  useAnalytics()
  useReferrals()
  useNetworkSwitching()

  useEffect(() => {
    document.body.classList.add('sl-theme-dark')
  }, [])

  registerIconLibrary('unicons', {
    resolver: (name) => {
      const match = name.match(/^(.*?)(-s)?$/)
      return `https://cdn.jsdelivr.net/npm/@iconscout/unicons@3.0.3/svg/${match[2] === '-s' ? 'solid' : 'line'}/${
        match[1]
      }.svg`
    },
    mutator: (svg) => svg.setAttribute('fill', 'currentColor'),
  })

  registerIconLibrary('social', {
    resolver: (name) => `/images/icons/social/${name}.svg`,
  })

  return (
    <Router>
      <GlobalStyles />
      <Layout />
      <ToastListener />
      <DatePickerPortal />
    </Router>
  )
}

export default React.memo(App)
